import { render } from "./Leagues.vue?vue&type=template&id=7f7bdb3a"
import script from "./Leagues.vue?vue&type=script&lang=js"
export * from "./Leagues.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__